import DateUtils from '../../../Utils/DateUtils';
import { CircularBar } from './CircularBar';

export class LevelTimer extends CircularBar {
    public started: boolean;

    constructor(time: number) {
        super(time.toString());
        this.setTime(time);
        this.label.scale.set(0.97);
        this.label.y = this.label.height / 4;
    }

    public setTime(time: number) {
        this.startTime = Date.now();
        this.depleteTime = time * 1000;
        this.pausedTime = 0;
        if (this.paused) {
            this.pauseTime = Date.now();
        }

        this.tick(true);
    }

    public tick(force?: boolean) {
        if ((!this.started && !force) || !super.tick(force)) {
            return false;
        }
        const time = Math.max(0, this.remainingTime / 1000);
        const timeText = this.getTimeText(time);
        if (this.label.text !== timeText) {
            this.label.text = timeText;
            this.label.tint = time <= 5 ? 0xff3403 : 0xfffa11;
        }
        return true;
    }

    private getTimeText(time: number) {
        return DateUtils.levelTimeToString(time);
    }
}
